/* eslint-disable max-len */
import { FilterAndSortField as AscOrderFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/aftersales_order/request/model/FilterAndSortField';
import { AftersalesOrderResponse } from '@1po/1po-bff-fe-spec/generated/aftersales_order/response/AftersalesOrderResponse';
import { ClaimAttachment, ClaimItem } from '@1po/1po-bff-fe-spec/generated/claim/request/CreateOrderClaimRequest';
import { FilterAndSortField as ClaimsFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/claim/request/model/FilterAndSortField';
import { GetGarageClaimPageResponse } from '@1po/1po-bff-fe-spec/generated/claim/response/GetGarageClaimPageResponse';
import { FilterBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterBy';
import { SortBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/SortBy';
import { DepositReturnListLine } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/model/DepositReturnListLine';
import { AddAscOrderItemToDepositReturnListRequest } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/request/AddAscOrderItemToDepositReturnListRequest';
import { ExadisReturnListLine } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/model/ExadisReturnListLine';
import { AddAscOrderItemToExadisReturnListRequest } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/request/AddAscOrderItemToExadisReturnListRequest';
import { MyClientsOrderDeliveryMethod as MyClientsOrderDeliveryMethodGenerated } from '@1po/1po-bff-fe-spec/generated/my_clients_order/model/MyClientsOrderDeliveryMethod';
import { FilterAndSortField as MyClientsOrderFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/my_clients_order/request/model/FilterAndSortField';
import { MyClientsOrderDetailResponse } from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderDetailResponse';
import {
  MyClientsOrderResponse,
  MyClientsOrderStatus as MyClientsOrderStatusGenerated,
} from '@1po/1po-bff-fe-spec/generated/my_clients_order/response/MyClientsOrderResponse';
import { FilterAndSortField } from '@1po/1po-bff-fe-spec/generated/order/request/model/FilterAndSortField';
import { ReturnReasonType } from '@1po/1po-bff-fe-spec/generated/order/request/ReturnEmailRequest';
import {
  CheckoutOverallStatus,
  OrderCheckoutResult,
} from '@1po/1po-bff-fe-spec/generated/order/response/CheckoutOrderResponse';
import {
  OrderItem,
  OrderReferenceItem,
  ReferenceBrandType,
  SubstituteReference,
} from '@1po/1po-bff-fe-spec/generated/order/response/GetDealerOrderPageResponse';
import { UserWithOrder } from '@1po/1po-bff-fe-spec/generated/order/response/GetGarageUsersWithOrderResponse';
import { ExternalOrderItem } from '@1po/1po-bff-fe-spec/generated/order/response/model/ExternalOrderItem';
import { APP_NAMESPACE } from 'app/App.constants';
import { UploadFileState } from 'components/FileUploadButton/Upload';
import { NO_DATA, SEARCH_STATUS, SearchData } from 'utils';

export interface OrderState {
  inProgressOrders: InProgressOrdersState;
  checkoutStatus: CheckoutOrderStatus | null;
  externalOrders: ExternalOrdersState;
  ascOrders: AscOrdersState;
  myClientsOrders: MyClientsOrdersState;
  exadisReturnList: ExadisReturnListState;
  depositReturnList: DepositReturnListState;
  claims: ClaimsState;
  garageUsersWithOrder: UserWithOrder[];
}

export interface ExadisReturnListState {
  returnList: SearchData<ExadisReturnListLine[]>;
  addItemStatus: SEARCH_STATUS;
}

export interface DepositReturnListState {
  returnList: SearchData<DepositReturnListLine[]>;
  addItemStatus: SEARCH_STATUS;
}

export interface CheckoutOrderStatus {
  placedOrders: OrderCheckoutResult[];
  failedOrders: OrderCheckoutResult[];
  ordersOverallStatus: CheckoutOverallStatus;
}

export interface ClaimsState {
  sendClaimStatus: SEARCH_STATUS;
  claimForm: ClaimForm;
  loadedClaims: SearchData<GetGarageClaimPageResponse>;
  uploadAttachments: Map<string, UploadFileState>;
  filters: Map<ClaimsFilterAndSortFieldLocal, string | string[]>;
  downloadingAttachmentIds: Set<string>;
  isVrnSearchLoading: boolean;
  exadisReturnClaimLineKeys: string[];
  depositReturnClaimLineKeys: string[];
}

export type AscOrderFilterAndSortFieldLocal = AscOrderFilterAndSortField | typeof DATE_FROM | typeof DATE_TO;

export type ClaimsFilterAndSortFieldLocal = ClaimsFilterAndSortField | typeof DATE_FROM | typeof DATE_TO;

export type MyClientsOrderFilterAndSortFieldLocal =
  | MyClientsOrderFilterAndSortField
  | typeof DATE_FROM
  | typeof DATE_TO;

export interface AscOrdersState {
  orders: SearchData<AftersalesOrderResponse>;
  filters: Map<AscOrderFilterAndSortFieldLocal, string>;
}

export interface MyClientsOrdersState {
  orders: SearchData<MyClientsOrderResponse>;
  selectedOrder: SearchData<MyClientsOrderDetailResponse>;
  filters: Map<MyClientsOrderFilterAndSortFieldLocal, string>;
  pagination: {
    pageSize: number;
    page: number;
  };
}

export interface ClaimVehicleInfo {
  vrn: string;
  registrationDate?: string;
  brand?: string;
  model?: string;
  energy?: string;
  engineCode?: string;
}

export interface ClaimLabourInfo {
  isFitted: boolean;
  labourTime?: string;
  fittingDate?: string;
  fittingMileage?: number;
  dismantlingDate?: string;
  dismantlingMileage?: number;
}

export interface ClaimForm {
  formType: ClaimFormType;
  reason: string;
  option?: string;
  orderNumber: string;
  deliveryNumber?: string;
  packageNumber?: string;
  invoiceNumber: string;
  invoiceLineNumber?: number;
  referenceNumberOrdered?: string;
  quantityOrdered?: number;
  referenceNumberReceived?: string;
  quantityReceived?: number;
  quantityInvoiced?: number;
  quantityClaimed?: number;
  message?: string;
  amount?: number;
  contact?: string;
  email?: string;
  phoneNumber?: string;
  pickupAddress?: string;
  pickupTimeSlots?: string;
  attachments?: ClaimAttachment[];
  shipToPartyId?: string;
  soldToPartyId?: string;
  vehicle?: ClaimVehicleInfo;
  labour?: ClaimLabourInfo;
  symptom?: string;
  claimItems?: ClaimItem[];
}
export const DIRECT_DELIVERY = 'DIRECT_DELIVERY';
export const FULL_OTC = 'FULL_OTC';
export const ASC = 'ASC';
export const ASC_EXADIS = 'ASC_EXADIS';
export const MULTI_ITEMS_DIRECT_DELIVERY = 'MULTI_ITEMS_DIRECT_DELIVERY';
export const MULTI_ITEMS_FULL_OTC = 'MULTI_ITEMS_FULL_OTC';
export const MULTI_ITEMS_EXADIS_RETURN = 'MULTI_ITEMS_EXADIS_RETURN';
export const MULTI_ITEMS_DEPOSIT_RETURN = 'MULTI_ITEMS_DEPOSIT_RETURN';
export type ClaimFormType =
  | typeof DIRECT_DELIVERY
  | typeof FULL_OTC
  | typeof ASC
  | typeof ASC_EXADIS
  | typeof MULTI_ITEMS_DIRECT_DELIVERY
  | typeof MULTI_ITEMS_FULL_OTC
  | typeof MULTI_ITEMS_EXADIS_RETURN
  | typeof MULTI_ITEMS_DEPOSIT_RETURN
  | undefined;
export type ClaimFormGroupType =
  | typeof DIRECT_DELIVERY
  | typeof FULL_OTC
  | typeof MULTI_ITEMS_DIRECT_DELIVERY
  | typeof MULTI_ITEMS_FULL_OTC
  | undefined;

export const MULTI_ITEMS_REASON_CODES: readonly string[] = ['Y04', 'Y07'];

export const MULTI_ITEMS_FORM_TYPES: readonly ClaimFormType[] = [MULTI_ITEMS_DIRECT_DELIVERY, MULTI_ITEMS_FULL_OTC];

export interface InProgressOrdersState {
  orderMap: Map<string, SearchData<OrderItemLocal>>;
  orderIds: SearchData<string[]>;
  cursor: string | undefined;
  hasMore: boolean;
  search?: string;
  removeOldData: boolean; // workaround for table flickering
  isLoading: boolean;
  sort: SortOption | undefined;
  filters: Map<SortKey, FilterBy<FilterAndSortField>>;
  activeFilters: Map<FilterAndSortField, string[]>;
  pendingOrderIdsToReAddToBasket: string[];
}

export interface OrderItemLocal extends Omit<OrderItem, 'orderedReferences'> {
  orderedReferences: OrderReferenceItemLocal[];
}

export interface OrderReferenceItemLocal extends Omit<OrderReferenceItem, 'substitutes'> {
  requestReason: ReturnReasonType | undefined;
  qtyToReturn: number;
  substitutes?: SubstituteReferenceLocal[];
}

export interface OrderReturnItem {
  index: number;
  referenceNumber: string;
  parentReferenceNumber?: string;
  name?: string;
  brand?: ReferenceBrandType;
  supplier?: string;
  qtyToReturn: number;
  requestReason: ReturnReasonType | undefined;
}

export interface SubstituteReferenceLocal extends SubstituteReference {
  requestReason: ReturnReasonType | undefined;
  qtyToReturn: number;
}

export type SortKey =
  | 'VEHICLE'
  | 'ORDER'
  | 'REFERENCE_NUMBER'
  | 'ORDER_MARK'
  | 'START_DATE'
  | 'END_DATE'
  | 'STATUS'
  | 'ORDERED_BY';

export type FilterKey = 'VEHICLE' | 'ORDER' | 'REFERENCE_NUMBER' | 'ORDER_MARK' | 'DATE' | 'STATUS' | 'ORDERED_BY';

export const DATE_FROM = 'DATE_FROM';
export const DATE_TO = 'DATE_TO';
export const ZCMR_ZGA2 = 'ZCMR_ZGA2';

export const AscOrdersFilterAndSortField: Record<AscOrderFilterAndSortField, AscOrderFilterAndSortField> = {
  DATE: 'DATE',
  ORDER: 'ORDER',
  ORDER_LOCAL: 'ORDER_LOCAL',
  REFERENCE_NUMBER: 'REFERENCE_NUMBER',
  DELIVERY_NUMBER: 'DELIVERY_NUMBER',
  INVOICE_NUMBER: 'INVOICE_NUMBER',
  STATUS: 'STATUS',
  SUPPLIER_NAME: 'SUPPLIER_NAME',
};

export const ClaimsFilterFields: Record<ClaimsFilterAndSortField, ClaimsFilterAndSortField> = {
  CLAIM_ID: 'CLAIM_ID',
  GARAGE_ID: 'GARAGE_ID',
  RP_4_CLAIM_ID: 'RP_4_CLAIM_ID',
  R_1_ORDER_ID: 'R_1_ORDER_ID',
  INVOICE_ID: 'INVOICE_ID',
  INVOICE_LINE_NUMBER: 'INVOICE_LINE_NUMBER',
  REFERENCE: 'REFERENCE',
  CODE: 'CODE',
  OPTION: 'OPTION',
  QUANTITY: 'QUANTITY',
  AMOUNT: 'AMOUNT',
  COMMENT: 'COMMENT',
  STATUS: 'STATUS',
  CREATED_AT: 'CREATED_AT',
  REFERENCE_NAME: 'REFERENCE_NAME',
  LAST_DOCUMENT_TYPE: 'LAST_DOCUMENT_TYPE',
  NOTE_ID: 'NOTE_ID',
};

export enum AscOrderStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
  DELIVERED = 'DELIVERED',
}

export const MyClientsOrderStatus: Record<MyClientsOrderStatusGenerated, MyClientsOrderStatusGenerated> = {
  CANCELLED: 'CANCELLED',
  DELIVERED: 'DELIVERED',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSING: 'PROCESSING',
  REJECTED: 'REJECTED',
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
  TO_BE_VALIDATED: 'TO_BE_VALIDATED',
  UNKNOWN: 'UNKNOWN',
};

export const MyClientsOrderDeliveryMethod: Record<
  MyClientsOrderDeliveryMethodGenerated,
  MyClientsOrderDeliveryMethodGenerated
> = {
  DESK: 'DESK',
  DIRECT: 'DIRECT',
  EXADIS_PICKUP: 'EXADIS_PICKUP',
  UNKNOWN: 'UNKNOWN',
};

export const MyClientsOrdersFilterAndSortField: Record<
  MyClientsOrderFilterAndSortField,
  MyClientsOrderFilterAndSortField
> = {
  GARAGE_NAME: 'GARAGE_NAME',
  ORDER_DATE: 'ORDER_DATE',
  ORDER_NUMBER: 'ORDER_NUMBER',
  RPARTSTORE_ORDER_NUMBER: 'RPARTSTORE_ORDER_NUMBER',
  SUPPLIER_NAME: 'SUPPLIER_NAME',
  SUPPLIER_ORDER_NUMBER: 'SUPPLIER_ORDER_NUMBER',
  DMS_ACKNOWLEDGED: 'DMS_ACKNOWLEDGED',
  URGENT: 'URGENT',
  VALUE_WITHOUT_TAX: 'VALUE_WITHOUT_TAX',
  STATUS: 'STATUS',
  MESSAGE: 'MESSAGE',
  BUYER_TRESOR_CODE: 'BUYER_TRESOR_CODE',
  BUYER_BIR_CODE: 'BUYER_BIR_CODE',
  BUYER_DMS_NUMBER: 'BUYER_DMS_NUMBER',
};

//extend this whenever you are working with order statuses as a constants
export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
}

export enum ClaimStatus {
  OK = 'OK',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_OK = 'IN_PROGRESS_OK',
  ACCEPTED = 'ACCEPTED',
  REFUSED = 'REFUSED',
}

export enum AscOrderDetailDeliveryStatus {
  FULLY_DELIVERED = 'fully delivered',
  COMPLETELY_DELIVERED = 'completely delivered',
  PARTIALLY_DELIVERED = 'partially delivered',
}

export interface ExternalOrdersState {
  orders: ExternalOrderItem[] | NO_DATA;
}

export type SortOption = 'DATE_DESC' | 'DATE_ASC' | 'PRICE_DESC' | 'PRICE_ASC';

export const sortOptionsMapping: Map<SortOption, SortBy<FilterAndSortField>> = new Map([
  ['DATE_DESC', { field: 'DATE', sortOperation: 'DESC' }],
  ['DATE_ASC', { field: 'DATE', sortOperation: 'ASC' }],
  ['PRICE_DESC', { field: 'PRICE', sortOperation: 'DESC' }],
  ['PRICE_ASC', { field: 'PRICE', sortOperation: 'ASC' }],
]);

export const ORDER_NAMESPACE = `${APP_NAMESPACE}/ORDER`;
export const GET_ORDER_LIST_EXPORT_REQUEST = `${ORDER_NAMESPACE}/GARAGE_ORDER_LIST_EXPORT_REQUEST`;
export const GET_ORDER_BY_ID_REQUEST = `${ORDER_NAMESPACE}/GET_ORDER_BY_ID_REQUEST`;
export const CHECKOUT_ORDER_REQUEST = `${ORDER_NAMESPACE}/CHECKOUT_ORDER_REQUEST`;
export const GET_EXTERNAL_ORDER_LIST_REQUEST = `${ORDER_NAMESPACE}/EXTERNAL_ORDER_LIST_REQUEST`;
export const RE_ADD_ORDER_REFERENCES_TO_BASKET = `${ORDER_NAMESPACE}/RE_ADD_ORDER_REFERENCES_TO_BASKET`;
export const SUBSCRIBE_SAP2B_CLAIM_MESSAGES = `${ORDER_NAMESPACE}/SUBSCRIBE_SAP2B_CLAIM_MESSAGES`;
export const ORDER_SEND_CLAIM_REQUEST = `${ORDER_NAMESPACE}/ORDER_SEND_CLAIM_REQUEST`;
export const FETCH_CLAIMS_REQUEST = `${ORDER_NAMESPACE}/FETCH_CLAIMS_REQUEST`;
export const GET_AFTERSALES_ORDER_LIST_REQUEST = `${ORDER_NAMESPACE}/GET_AFTERSALES_ORDER_LIST_REQUEST`;
export const GET_MY_CLIENTS_ORDER_LIST_REQUEST = `${ORDER_NAMESPACE}/GET_MY_CLIENTS_ORDER_LIST_REQUEST`;
export const GET_MY_CLIENTS_ORDER_DETAIL_REQUEST = `${ORDER_NAMESPACE}/GET_MY_CLIENTS_ORDER_DETAIL_REQUEST`;
export const UPDATE_MY_CLIENTS_ORDER_FILTER_AND_REFETCH_LIST = `${ORDER_NAMESPACE}/UPDATE_MY_CLIENTS_ORDER_FILTER_AND_REFETCH_LIST`;
export const GET_CLAIM_DOCUMENT_UPLOAD_URL_REQUEST = `${ORDER_NAMESPACE}/GET_CLAIM_DOCUMENT_UPLOAD_URL_REQUEST`;
export const GET_CLAIM_DOCUMENT_DOWNLOAD_URL_REQUEST = `${ORDER_NAMESPACE}/GET_CLAIM_DOCUMENT_DOWNLOAD_URL_REQUEST`;
export const GET_GARAGE_USERS_WITH_ORDER_REQUEST = `${ORDER_NAMESPACE}/GET_GARAGE_USERS_WITH_ORDER_REQUEST`;
export const FETCH_VRN_VEHICLE_INFO_REQUEST = `${ORDER_NAMESPACE}/FETCH_VRN_VEHICLE_INFO_REQUEST`;
export const ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_REQUEST = `${ORDER_NAMESPACE}/ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_REQUEST`;
export const GET_CURRENT_EXADIS_RETURN_LIST_REQUEST = `${ORDER_NAMESPACE}/GET_CURRENT_EXADIS_RETURN_LIST_REQUEST`;
export const ORDER_REMOVE_EXADIS_RETURN_LIST_ITEMS_REQUEST = `${ORDER_NAMESPACE}/ORDER_REMOVE_EXADIS_RETURN_LIST_ITEMS_REQUEST`;
export const ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_REQUEST = `${ORDER_NAMESPACE}/ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_REQUEST`;
export const GET_CURRENT_DEPOSIT_RETURN_LIST_REQUEST = `${ORDER_NAMESPACE}/GET_CURRENT_DEPOSIT_RETURN_LIST_REQUEST`;
export const ORDER_REMOVE_DEPOSIT_RETURN_LIST_ITEMS_REQUEST = `${ORDER_NAMESPACE}/ORDER_REMOVE_DEPOSIT_RETURN_LIST_ITEMS_REQUEST`;

export interface AddExadisReturnListItemSelection extends AddAscOrderItemToExadisReturnListRequest {
  sourceInvoicedQuantity: number;
}

export interface ExadisReturnListItemLocal extends ExadisReturnListLine {
  isSelected?: boolean;
}

export interface AddDepositReturnListItemSelection extends AddAscOrderItemToDepositReturnListRequest {
  sourceInvoicedQuantity: number;
}

export interface DepositReturnListItemLocal extends DepositReturnListLine {
  isSelected?: boolean;
}
